type NonEmptyArray<T> = [T, ...T[]];

export const isArrayNotEmpty = <T>(
  data?: unknown | null
): data is NonEmptyArray<T> => !!data && Array.isArray(data) && data.length > 0;
